














































import Vue from 'vue';
import Component from 'vue-class-component';
import { Provide, Prop, Watch } from 'vue-property-decorator';
import { ConfiguratorService } from '../services/sketchfab/index';
import { setTimeout } from 'timers';
import { Store } from '@/store';
import { ComponentContainer } from '@/services/container';
import { ServiceIdentifiers } from '@/services';
import { Types, ConfigurationServiceInitiated } from '@/models/events';
import { ProductDefinition } from '@/models/configurator';
import * as _ from 'lodash';
import SketchfabFrame from '@/components/skecthfabFrame/SketchfabFrame.vue';
import { config } from 'bluebird';
import $ from 'jquery';
import AssemblySteps from '@/components/assembly/AssemblySteps';
import { IProductDefinition,ProductDefinitions } from  '@/models/assembly';
import Room from '@/components/room/Room';

@Component({
  components: {
    sketchfab: SketchfabFrame,
    room: Room,
  },
})
export default class RoomConfigurator extends Vue {
  public initiated: boolean = false;
  public isMobile: boolean = false;
  public sketchfabOptions = {
    sketchfabModelId: null,
    textureBaseUrl: null,
  };

  @Prop() productId: string;
  @Prop() lang: string;

  windowHeight: number = 0;

  @Provide() private _container: ComponentContainer = null;
  private _configuratorService : ConfiguratorService;

  beforeCreate() {
    this._container = new ComponentContainer();
  }

  created() {
    this.isMobile = window.innerWidth < 1000;
    if (this.lang) {
      this.$root.$data.locale = this.lang;
    }

    this.sketchfabOptions.textureBaseUrl =
      Store.roomState.roomConfiguratorConfig.textureBaseUrl;

    let product = _.find(Store.roomState.roomConfiguratorConfig.products,x => x.id === this.productId);
    if (!product) {
      product = Store.roomState.roomConfiguratorConfig.products[0];

    }
    Store.roomState.room = product;

    this.sketchfabOptions.sketchfabModelId = product.sketchfabModelId;

    this.$root.$on(Types.ConfigurationServiceInitiatedEvent,(event: ConfigurationServiceInitiated) => {
      this._configuratorService = Store.getConfiguratorService(event.sketchfabModelId);
      this._container.register(ServiceIdentifiers.ConfiguratorService, () => Store.getConfiguratorService(event.sketchfabModelId));
      this.initiated = true;

      console.log(this._configuratorService.nodes);

    });
  }

  @Watch('windowHeight')
  watchWindowHeight(newHeight, oldHeight) {
    this.isMobile = newHeight < 1000;
  }
  private getSelectOptionsFromBase64String(selectedOptionsBase64: string) {
    if (!selectedOptionsBase64) {
      return null;
    }
    const json = this.base64Decode(selectedOptionsBase64);
    const o = JSON.parse(json);
    if (o == null) {
      return null;
    }

    return o;
  }

  base64Decode(base64: string): string {
    return decodeURIComponent(encodeURIComponent(window.atob(base64)));
  }

  clickedElement(e: any) {
    $('.navbar-toggler').click();
  }


  mounted() {

    this.$nextTick(() => {
      window.addEventListener('resize', (e) => {
        this.windowHeight = window.innerWidth;
      });
      $(document).on('click', '.js--close', e => this.clickedElement(e));


    });
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RoomConfigurator.vue